import styled from 'styled-components';

export const Subheader = styled('div')`
  padding: ${({ theme: { spacing } }) => spacing(4)};
  padding-top: ${({ theme: { spacing } }) => spacing(14.5)};
`;
